import {
  PayeeRequirement,
  PayerEngagement,
  RequirementStatus
} from "@wingspanhq/wingspan-api-sdk";
import { selectorPayerEngagementRequirements } from "./selectorPayerEngagementRequirements";

/**
 * Whether an assignment is eligible for payment — every requirement attached to
 * it is complete.
 *
 * v1 read a server-supplied `paymentsEligibility` off the engagement. v3 has no
 * such field on `PayerEngagement`, so this is a derivation. It is per-engagement,
 * where the search row's rollup was per-CLIENT (every engagement on a client
 * shared one value), so it is strictly closer to the truth — but it is still a
 * derivation and not the server's own signal.
 */
export const selectorIsPayerEngagementEligible = ({
  engagement,
  requirements
}: {
  engagement: PayerEngagement;
  requirements: PayeeRequirement[];
}): boolean =>
  selectorPayerEngagementRequirements({ engagement, requirements }).every(
    requirement => requirement.status === RequirementStatus.COMPLETED
  );
